import styles from './BranchPage.module.scss';
import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import LoadingIndicator from '../components/loading-indicator/LoadingIndicator';
import { ProfileBar } from '../components/profile-bar/ProfileBar';
import MainNav from '../components/main-nav/MainNav';
import { Transfer } from '../common/transfer/Transfer';
import bphone from 'assets/images/phone-blue.svg';
import branchImg from 'assets/images/branch.svg';
import locationImg from 'assets/images/profile-pin.svg';
import { commonActions } from '../../stores/_actions';
import { Pagination } from 'semantic-ui-react';
import { NoRecord } from 'views/common/norecord/norecord';
function BranchPage(props) {
  const profile = JSON.parse(localStorage.getItem('userProfile'));
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));
  const [branche, setBranches] = useState({
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      BankCode: '00001',
      // CustomerCode: profile.CustomerCode,
    },
    Status: false,
    SessionID: null,
    IdType: null,
    FileType: null,
    Langcode: null,
  });

  const payload = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Status: false,
    SessionID: sessionId,
    IdType: null,
    langcode: '0001',
    Data: {
      CustomerCode: profile?.CustomerCode,
    },
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(commonActions.branches(branche));
    dispatch(commonActions.getCustDetailsByCode(payload));
  }, []);

  let branch;
  let status;
  useSelector((state) => {
    branch = state.branches.data;
    status = state.branches.branches;
  }, []);

  const [pager, setPage] = useState({
    page: 1,
    itemsPerPage: 8,
  });
  const setPageNum = (event, { activePage }) => {
    setPage({ page: activePage });
  };
  const itemsPerPage = 8;
  const { page } = pager;
  const totalPages = Math.ceil(branch && branch.length / itemsPerPage) || 1;
  const items = branch && branch.slice((page - 1) * itemsPerPage, (page - 1) * itemsPerPage + itemsPerPage);
  const orgBranch =
    items &&
    items.map((item, index) => {
      return (
        <div key={item.BranchCode} className={styles.beneficiary__Bitem}>
          <div className={styles.branchBox}>
            <div className={styles.branchBox__left}>
              <h2>{item.BranchName}</h2>
              {item.Address ? (
                <p>
                  <img src={locationImg} alt="" />
                  {item.Address}
                </p>
              ) : (
                ''
              )}
              {item.Phone ? (
                <p>
                  <img src={bphone} alt="" />
                  {item.Phone}
                </p>
              ) : (
                ''
              )}
            </div>
            <img src={branchImg} alt="" />
          </div>
        </div>
      );
    });
  let userProfile;
  useSelector((state) => {
    userProfile = state.getCustDetails?.data;
  });

  return (
    <LoadingIndicator>
      <div className={styles.mainContainer}>
        <MainNav />
        <div className={styles.mainContainer__contentPart}>
          <ProfileBar profile={userProfile} />
          <div className={styles.mainContainer__pageCont}>
            <div className={styles.pageLeft}>
              <div className={styles.beneficiary}>
                <div className={styles.beneficiary__item}>{orgBranch ? orgBranch : <NoRecord status={status} />}</div>
              </div>
              {branch ? (
                <div className={styles.pageCount}>
                  <div className={styles.pageCountcont}>
                    <span>{page}</span> / <span>{totalPages}</span>
                  </div>
                  <div className={styles.carousal}>
                    <Pagination
                      boundaryRange={0}
                      defaultActivePage={page}
                      ellipsisItem={null}
                      firstItem={null}
                      lastItem={null}
                      siblingRange={null}
                      totalPages={totalPages}
                      onPageChange={setPageNum}
                    />
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>
            <div className={styles.pageRight}>
              <Transfer />
            </div>
          </div>
        </div>
      </div>
    </LoadingIndicator>
  );
}

export { BranchPage };
